/**
 * Formato numérico de la grilla del packing list (es-CL: miles y decimales con coma).
 */

export function parsePlNumberInput(v) {
  if (v == null || v === '') return null;
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  const raw = String(v).trim().replace(/\s/g, '');
  if (!raw) return null;
  let normalized = raw;
  if (raw.includes(',')) {
    normalized = raw.replace(/\./g, '').replace(',', '.');
  } else if (/^-?\d{1,3}(\.\d{3})+$/.test(raw)) {
    normalized = raw.replace(/\./g, '');
  }
  const n = Number.parseFloat(normalized);
  return Number.isFinite(n) ? n : null;
}

export function formatPlNumber(v, { min = 0, max = 2 } = {}) {
  const n = parsePlNumberInput(v);
  if (n == null || Number.isNaN(n)) return '';
  return n.toLocaleString('es-CL', {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  });
}

/** Paquetes, pcs/paq, etc. en la grilla del PL (es-CL). */
export function formatPackingListMiles(v) {
  return formatPlNumber(v, { min: 0, max: 2 });
}

/** Ancho / largo como en PDF packing list: miles con coma (ej. 2134 → 2,134). */
export function formatPackingListWidthLength(v) {
  const n = parsePlNumberInput(v);
  if (n == null || Number.isNaN(n)) return '';
  if (Number.isInteger(n)) {
    return n.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  return n.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/** Volumen m³ en la grilla del PL (hasta 3 decimales, coma decimal). */
export function formatPackingListM3(v) {
  const n = parsePlNumberInput(v);
  if (n == null || Number.isNaN(n)) return '';
  return n.toLocaleString('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
}
